import React from "react";

export const Illustration2 = () => (
	<svg width={370} height={81} viewBox="0 0 370 81" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M33.3549 22.9717C-6.96243 44.9916 3.8023 69.5269 33.3549 80H345.787C389.813 44.648 334.964 10.3749 290.732 18.201C201.244 34.0344 181.142 13.276 145.613 9.46316C74.6964 1.85271 62.6464 6.97373 33.3549 22.9717Z"
			fill="#F5FAFF"
		/>
		<path d="M0 79L370 79" stroke="#315C84" strokeWidth={2} />
		<path
			d="M214 40H262C264.209 40 266 41.7909 266 44V79H210V44C210 41.7909 211.791 40 214 40Z"
			fill="#F9FCFF"
			stroke="#315C84"
			strokeWidth={2}
		/>
		<path
			d="M147 1H209C211.209 1 213 2.79086 213 5V79H143V5C143 2.79086 144.791 1 147 1Z"
			fill="#F9FCFF"
			stroke="#315C84"
			strokeWidth={2}
		/>
		<line x1={167} y1={15} x2={206} y2={15} stroke="#C4DBF1" strokeWidth={2} />
		<line x1={167} y1={27} x2={192} y2={27} stroke="#C4DBF1" strokeWidth={2} />
		<line x1={167} y1={41} x2={206} y2={41} stroke="#C4DBF1" strokeWidth={2} />
		<path d="M214 41H262C263.657 41 265 42.3431 265 44V51H214V41Z" fill="#C4DBF1" fillOpacity={0.49} />
		<line x1={167} y1={54} x2={206} y2={54} stroke="#C4DBF1" strokeWidth={2} />
		<line x1={159} y1={69} x2={206} y2={69} stroke="#C4DBF1" strokeWidth={2} />
		<rect x={151} y={16} width={9} height={9} rx={1} fill="#C4DBF1" fillOpacity={0.49} />
		<rect x={151} y={43} width={9} height={9} rx={1} fill="#C4DBF1" fillOpacity={0.49} />
		<path d="M151 19.5L155.278 23L162 16" stroke="#315C84" strokeWidth={2} />
		<path d="M151 45.5L155.278 49L162 42" stroke="#315C84" strokeWidth={2} />
		<circle cx={65.5} cy={16.5} r={2.5} stroke="#315C84" strokeWidth={2} />
		<circle cx={343.5} cy={37.5} r={2.5} stroke="#315C84" strokeWidth={2} />
		<circle cx={66.5} cy={70.5} r={2.5} stroke="#315C84" strokeWidth={2} />
		<line x1={27} y1={62} x2={35} y2={62} stroke="#315C84" strokeWidth={2} />
		<line x1={31} y1={58} x2={31} y2={66} stroke="#315C84" strokeWidth={2} />
		<line x1={296} y1={16} x2={304} y2={16} stroke="#315C84" strokeWidth={2} />
		<line x1={300} y1={12} x2={300} y2={20} stroke="#315C84" strokeWidth={2} />
		<line x1={309} y1={67} x2={317} y2={67} stroke="#315C84" strokeWidth={2} />
		<line x1={313} y1={63} x2={313} y2={71} stroke="#315C84" strokeWidth={2} />
		<line x1={220} y1={34} x2={220} y2={40} stroke="#315C84" strokeWidth={2} />
		<line x1={227} y1={34} x2={227} y2={40} stroke="#315C84" strokeWidth={2} />
		<line x1={235} y1={34} x2={235} y2={40} stroke="#315C84" strokeWidth={2} />
		<line x1={242} y1={34} x2={242} y2={40} stroke="#315C84" strokeWidth={2} />
		<path
			d="M278.013 56.6957L259.099 66.8434L255.251 65.6543L256.463 61.7289L275.36 51.5894L278.013 56.6957ZM281.537 48.2768C281.756 48.1592 282.018 48.2403 282.133 48.461L284.363 52.755C284.483 52.9851 284.394 53.2726 284.165 53.3951L281.724 54.7044L279.072 49.5984L281.537 48.2768Z"
			fill="#F5FAFF"
			stroke="#315C84"
			strokeWidth={2}
		/>
		<line x1={250} y1={34} x2={250} y2={40} stroke="#315C84" strokeWidth={2} />
		<line x1={257} y1={34} x2={257} y2={40} stroke="#315C84" strokeWidth={2} />
		<line x1={221} y1={58} x2={249} y2={58} stroke="#315C84" strokeWidth={2} />
		<line x1={221} y1={66} x2={239} y2={66} stroke="#315C84" strokeWidth={2} />
		<circle
			cx={111.198}
			cy={51.1982}
			r={19.5}
			transform="rotate(-1.98642 111.198 51.1982)"
			fill="#F9FCFF"
			stroke="#315C84"
			strokeWidth={2}
		/>
		<path
			d="M109.686 60.7958L101.14 54.5563C100.627 54.1814 100.477 53.4365 100.806 52.8924L101.997 50.9223C102.326 50.3782 103.009 50.2411 103.522 50.616L109.279 54.8192L117.178 41.7539C117.507 41.2099 118.19 41.0728 118.703 41.4477L120.563 42.8052C121.076 43.1801 121.226 43.925 120.897 44.4691L111.211 60.4896C110.882 61.0336 110.2 61.1708 109.686 60.7958Z"
			fill="#C4DBF1"
		/>
	</svg>
);
